import Api from '../Api';

class CountryApi extends Api {
  constructor() {
    super('countries', 'countries');
  }
}
const countryApi = new CountryApi();
export default countryApi;
